import ExceptionHandling from './ExceptionHandling.js'
import { useStore, ActionTypes } from "../store";
import instance from './index';

export default class OptionTag {

	getItems(tag,start) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/options_list';
		const formData = new FormData();
		formData.append('tag', tag);
		formData.append('start', start);
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
		.catch((e) => ExceptionHandling.HandleErrors(e))
		.finally(() => {
			store.dispatch(ActionTypes.PROGRESS_BAR, false);
		})
	}

	saveItem(postObj,optionName) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/add_option';
		const formData = new FormData();
		formData.append('optionName', optionName);
		formData.append('description', postObj.description);
		formData.append('optionType', postObj.optionType.key);
		formData.append('status', postObj.status);
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	save(postObj) {
			//console.log("save junction caled in js");
			//SHOW LOADING
			const store = useStore();
			store.dispatch(ActionTypes.PROGRESS_BAR, true);
			const api = '/api/save_option_tag_bulk';
			const formData = new FormData();
			formData.append('item_list', JSON.stringify(postObj));
			return instance()(
				{
					method: 'post',
					url: api,
					data: formData,
				}
			).then(res => res.data)
				.catch((e) => ExceptionHandling.HandleErrors(e))
				.finally(() => {
					store.dispatch(ActionTypes.PROGRESS_BAR, false);
				})
		}

	

	updateItem(postObj,optionName) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/edit_option';
		const formData = new FormData();
		formData.append('id', postObj.id);
		formData.append('option_name', optionName);
		formData.append('description', postObj.description);
		formData.append('option_type', postObj.optionType.key);

		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	getItem(data) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/get_option/' + data.id;
		return instance().get(api)
			.then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	changeStatus(postObj) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/delete_option';
		const formData = new FormData();
		formData.append('id', postObj.id);
		formData.append('status', postObj.status);

		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	 exportSampleStock()
		{
			const store = useStore();
			store.dispatch(ActionTypes.PROGRESS_BAR, true);
			const api = '/api/export_sample_option_tags';
			const formData = new FormData();
			return instance()(
				{
					method: 'post',
					url: api,
					data: formData,
				}
			).then(res => res.data)
				.catch((e) => ExceptionHandling.HandleErrors(e))
				.finally(() => {
					store.dispatch(ActionTypes.PROGRESS_BAR, false);
				})
		}
	
		uploadCSVFile(image) {
			//console.log("upload csv in js");
			//SHOW LOADING
			const store = useStore();
			store.dispatch(ActionTypes.PROGRESS_BAR, true);
			const api = '/api/import_sample_option_tags';
			const formData = new FormData();
			formData.append('image', image);
	
			return instance()(
				{
					method: 'post',
					url: api,
					data: formData,
				}
			).then(res => res.data)
				.catch((e) => ExceptionHandling.HandleErrors(e))
				.finally(() => {
					store.dispatch(ActionTypes.PROGRESS_BAR, false);
				})
		}

}